const theme = {
  colors: {
    primary: "#8CD4A1",
    gray1: "#171717",
    gray2: "#47484C",
    gray3: "#858588",
    gray4: "#C7C8C9",
    gray5: "#DFDFE0",
  },
  fonts: {
    primary: "'Pretendard', sans-serif",
    secondary: "'NeoDunggeunmoPro', sans-serif",
  },
  weight: {
    bold: "700",
    semibold: "600",
    regular: "500",
  },
};

export default theme;
